import React from 'react';
import './OurStory.css';
import realtorGP from '../../assets/images/our-story/realtorgp.jpg';

const OurStory = ({ handleScheduleClick }) => {
  return (
    <div className="our-story-container">
      <section className="hero-section">
        <h1>Our Story: We Got Burned Too.</h1>
        <h2>We Were Property Managers, Realtors, and Customers First.</h2>
      </section>

      <section className="story-section">
        <p className="intro-text">
          In 2017, we weren't trying to start a handyman company — we were just trying to get help.
        </p>
        
        <div className="problem-list">
          <p>We were flipping homes and managing rentals, and every small repair became a nightmare:</p>
          <ul>
            <li>Contractors wouldn't touch anything under $50,000</li>
            <li>Plumbers and electricians charged $150 just to show up</li>
            <li>AC companies took four calls to get someone out… then billed $350 before even diagnosing</li>
            <li>Utility vendors gave 4–6 hour windows — and still ran late</li>
            <li>Worst of all, when someone did show up, the quality didn't match the price</li>
          </ul>
        </div>

        <p className="solution-text">
          We weren't just frustrated — we were fed up. So we built what we needed: a reliable, honest, fast, and fair handyman service.
        </p>
      </section>

      <section className="mission-section">
        <h2>Breakthrough Handyman Was Built to Be the Alternative.</h2>
        <p>Not a franchise. Not a patch job. Not overpriced.</p>
        <p>Just real, professional handymen — with real appointment times, clear pricing, and accountability.</p>

        <div className="goal-box">
          <h3>Our goal was simple:</h3>
          <ul>
            <li>Show up.</li>
            <li>Do it right.</li>
            <li>Make it easy.</li>
            <li>Leave customers smiling.</li>
          </ul>
        </div>
      </section>

      <section className="results-section">
        <h2>And It Worked.</h2>
        <p>Since 2017, we've completed 12,500+ jobs for just over 6,000 customers — because most of our clients call us back multiple times a year.</p>

        <div className="why-box">
          <h3>Why?</h3>
          <ul>
            <li>Because we respect your time.</li>
            <li>We quote with real data.</li>
            <li>We don't mark up materials.</li>
            <li>And you don't pay until you're happy.</li>
          </ul>
        </div>
      </section>

      <section className="handymen-section">
        <h2>We Also Built Something Better for the Handymen.</h2>
        <p>Most of our handymen are full-time with us — not gig workers.</p>
        <p>They're professionals. They have families. They take pride in what they do. They show up on time, they walk you through what's happening, and they don't leave until you're taken care of.</p>
        <p>We built a system that lets them focus on the work — and lets you trust the person walking into your home.</p>
      </section>

      <section className="differentiators-section">
        <h2>What Makes Us Different?</h2>
        <div className="differentiators-grid">
          <div className="differentiator-item">Real appointment times — no vague "windows"</div>
          <div className="differentiator-item">Same-day or next-day availability in most cases</div>
          <div className="differentiator-item">Honest pricing based on 12,500 jobs of data</div>
          <div className="differentiator-item">No markup on materials — ever</div>
          <div className="differentiator-item">You don't pay until you approve the work</div>
          <div className="differentiator-item">If something goes wrong, we own it and fix it</div>
          <div className="differentiator-item">Local, family-owned, and proud of it</div>
        </div>
      </section>

      <section className="conclusion-section">
        <h2>We Started as Customers Who Got Burned.</h2>
        <p>Now we're here to protect homeowners, property managers, and families just like you.</p>
        <p>We don't aim for perfection — we aim to make it right. And we've built a business on doing exactly that.</p>
        
        <div className="team-photo-placeholder">
          <div className="team-content">
            <div className="team-text">
              <h2 className="real-people-text">
                Real People.<br />
                Real Pride.<br />
                Real Results.
              </h2>
            </div>
            <div className="team-image">
              <img src={realtorGP} alt="Our team" />
            </div>
          </div>
        </div>

        <div className="cta-box">
          <h3>💬 Want to see the difference for yourself?</h3>
          <p>Ask Alex, our smart assistant, if we can help today.</p>
          <button className="cta-button secondary" onClick={handleScheduleClick}>Chat Now or Call Us</button>
        </div>
      </section>
    </div>
  );
};

export default OurStory; 